export default "__VITE_ASSET__bf98d589__"